import {
	createRouter, createWebHistory, RouterView, 
} from "vue-router";

/**
 * The page picks its view from the handshake query params, not the path, so there is no
 * RouterView in the tree. The router exists only because Nuxt UI's button renders a router
 * link and warns when the injection is missing.
 */
const router = createRouter({
	history: createWebHistory(),
	routes: [
		{
			component: RouterView,
			name: "home",
			path: "/:pathMatch(.*)*",
		},
	],
});

export default router;
